module.exports = __webpack_public_path__ + "img/reports.fc678725.png";